// @flow
import { emailPattern } from './constants';

const validateEmailAddress = (email) => email.match(emailPattern);

export default validateEmailAddress;
